// extracted by mini-css-extract-plugin
module.exports = {"page":"delta-3-plus-portable-power-station_page__APEsL","spin":"delta-3-plus-portable-power-station_spin__2xO6S"};